import { createGraphQLRequest } from "../../../../api/utils/httpRequest"
import type {
    SpecialPricingReportRequestData,
    VoidsLogReportItem,
    VoidsSummaryReportItem,
} from "../../../../graphql/types"

export const fetchVoidsLogReport = (
    headers: Record<string, any>,
    data: SpecialPricingReportRequestData
): Promise<VoidsLogReportItem[]> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                query voidsLogReport($data: SpecialPricingReportRequestData!) {
                  voidsLogReport(data: $data) {
                    id
                    accountId
                    amount
                    approvalName
                    assigneeName
                    content
                    entityNumber
                    locationName
                    originTimestamp
                    terminalName
                    reasonCode
                  }
                }
            `,
            operationName: "voidsLogReport",
            variables: {
                data: data,
            },
        },
    }).then(response => {
        if (response && response.data && response.data.voidsLogReport) {
            return response.data.voidsLogReport
        }

        return []
    })

export const fetchVoidsSummaryReport = (
    headers: Record<string, any>,
    data: SpecialPricingReportRequestData
): Promise<VoidsSummaryReportItem[]> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                query voidsSummaryReport($data: SpecialPricingReportRequestData!) {
                  voidsSummaryReport(data: $data) {
                      ...VoidsSummaryReportData
                  }
                }
               
                fragment VoidsSummaryReportData on VoidsSummaryReportItem {
                    row_number
                    account_id
                    type
                    item_name
                    reason_code
                    quantity
                    amount
                }
    
            `,
            operationName: "voidsSummaryReport",
            variables: {
                data: data,
            },
        },
    }).then(response => {
        if (response && response.data && response.data.voidsSummaryReport) {
            return response.data.voidsSummaryReport
        }

        return []
    })
